import { render } from "./DocumentationStep.vue?vue&type=template&id=4ebf7bf1&scoped=true"
import script from "./DocumentationStep.vue?vue&type=script&lang=js"
export * from "./DocumentationStep.vue?vue&type=script&lang=js"

import "./DocumentationStep.vue?vue&type=style&index=0&id=4ebf7bf1&scoped=true&lang=css"

import exportComponent from "../../../../../app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ebf7bf1"]])

export default __exports__